// src/internal/components/help-center-panel/events.ts
var EXPERIENCE_HELPERSIDE_OPEN = "EXPERIENCE_HELPERSIDE_OPEN";
var EXPERIENCE_HELPERSIDE_CLOSE = "EXPERIENCE_HELPERSIDE_CLOSE";
var EXPERIENCE_HELPERSIDE_SEARCH = "EXPERIENCE_HELPERSIDE_SEARCH";
var EXPERIENCE_HELPERSIDE_ARTICLE_OPEN = "EXPERIENCE_HELPERSIDE_ARTICLE_OPEN";
var EXPERIENCE_HELPERSIDE_CHAT_OPEN = "EXPERIENCE_HELPERSIDE_CHAT_OPEN";
var EXPERIENCE_HELPERSIDE_ERROR = "EXPERIENCE_HELPERSIDE_ERROR";
var EXPERIENCE_HELPERSIDE_CREATE_TICKET = "EXPERIENCE_HELPERSIDE_CREATE_TICKET";
var HelpCenterEvents = {
  EXPERIENCE_HELPERSIDE_OPEN,
  EXPERIENCE_HELPERSIDE_CLOSE,
  EXPERIENCE_HELPERSIDE_SEARCH,
  EXPERIENCE_HELPERSIDE_ARTICLE_OPEN,
  EXPERIENCE_HELPERSIDE_CHAT_OPEN,
  EXPERIENCE_HELPERSIDE_ERROR,
  EXPERIENCE_HELPERSIDE_CREATE_TICKET
};

export {
  HelpCenterEvents
};
